import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FileTile.html?raw';
import on from 'dojo/on';
import Button from '../../moreCore/UI/Button/Button';
import "../../moreCore/UI/Button/Button";
import FilterPanel from '../../moreCore/UI/FilterPanel/FilterPanel';
import "../../moreCore/UI/FilterPanel/FilterPanel";
import ExpandableSection from '../../moreCore/UI/Container/ExpandableSection';
import "../../moreCore/UI/Container/ExpandableSection";
import domConstruct from 'dojo/dom-construct';
//import emailFormStandalone = require("../EMail/emailFormStandalone");

import { FileDashboard } from "../FileDashboard/FileDashboardTypes";
import { FileHelpers, HtmlHelpers, TranslationHelpers } from "../../more/Helpers";
import emailForm from '../EMail/emailForm';

import filePreview from '../filePreview/filePreview';

class FileTile extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private filterPanel: MdsLax<InstanceType<typeof FilterPanel>>;
    private fileTableRows: Array<HTMLElement> = [];
    private innerContent: HTMLElement;
    private headingNode: HTMLHeadingElement;
    private descriptionNode: HTMLHeadingElement;
    private iconContainer: HTMLElement;
    private iconNode: HTMLElement;
    private filterPanelContainer: HTMLElement;
    private availableFilesContainer: HTMLElement;
    private sectionAvailableFiles: HTMLElement;
    private sectionFilterPanel: HTMLElement;
    private noEntriesNode: HTMLElement;
    private animationContainer: HTMLElement;
    private animationBar: HTMLElement;
    private _hiddenNode: HTMLElement;

    //expanderFiles: ExpandableSection;
    expanderFilterpanel: MdsLax<InstanceType<typeof ExpandableSection>>;

    private table: HTMLTableElement = null;

    internalName: string = "";

    private config: FileDashboard.TileConfig;

    private tileData: FileDashboard.TileData;

    setup(config: FileDashboard.TileConfig, data: FileDashboard.TileData) {
        if (config) this.config = config;

        if (data) this.setData(data);
    }

    setData(data: FileDashboard.TileData) {
        this.tileData = data;

        this._applyData();
    }

    private _applyData(): void {
        let settings = this.tileData;

        this.headingNode.innerHTML = settings.title;

        this.internalName = settings.name;

        if (settings.icon) {
            this.iconNode.className = settings.icon;
            this.hideNode(this.iconContainer, false);
        }

        if (settings.description) {
            this.descriptionNode.innerHTML = settings.description;
            this.hideNode(this.descriptionNode, false);
        } else {
            this.hideNode(this.descriptionNode);
        }

        if (settings.color) {
            if (settings.color.colorHex) {
                this.domNode.style.setProperty("--txtColor", settings.color.colorHex);
            }

            if (settings.color.backgroundHex) {
                this.domNode.style.setProperty("--bgColor", settings.color.backgroundHex);
            }
        //    this.UiModder.domStyle.set(this.innerContent, "color", settings.color.colorHex);
        //    this.UiModder.domStyle.set(this.innerContent, "backgroundColor", settings.color.backgroundHex);
        }

        this.constructFilterPanel();

        this.prepareFilesSection();
    }

    private constructFilterPanel(): void {
        this.UiModder.domConstruct.empty(this.filterPanelContainer);
        this.hideNode(this.sectionFilterPanel);
        this.filterPanel = null;

        if (!this.tileData.filterPanel) {
            return;
        }

        if (this.tileData.filterPanel.title) {
            this.expanderFilterpanel.setHeading(this.tileData.filterPanel.title);
        }

        this.expanderFilterpanel.setCollapsible(this.tileData.filterPanel.isCollapsible);
        this.expanderFilterpanel.toggleExpand(!this.tileData.filterPanel.isCollapsed);



        let filterPanelData = this.tileData.filterPanel.config;

        if (!filterPanelData) return;

        this.hideNode(this.sectionFilterPanel, false);

        let filterPanel = new FilterPanel();
        this.filterPanel = filterPanel;


        // config wird übersteuert. nix mehr aus KF:
        filterPanelData.buttonConfig = {
            buttonClassesDisabled: null,
            buttonClassesEnabled: null,
            buttonIconClass: "fas fa-print",
            buttonLabel: this.translate("General_Create")
        }


        filterPanel.setButtonConfig(filterPanelData.buttonConfig);

        filterPanel.setSectionData(filterPanelData.sections);

        filterPanel.placeAt(this.filterPanelContainer);
        filterPanel.startup();

        //let centerrow = domConstruct.create("div", { "className": "buttonRow" }, filterPanel.domNode);
        //let button = new Button();
        //button.setLabel("GO");
        //button.setReadonly(true);
        //button.placeAt(centerrow);

        on(filterPanel, "submitClick", lang.hitch(this, this._onClick_SubmitFilterpanel, filterPanel));

        filterPanel.serializeData();
    }

    private prepareFilesSection(): void {
        this.UiModder.domConstruct.place(this.noEntriesNode, this._hiddenNode);
        this.UiModder.domConstruct.empty(this.availableFilesContainer);

        //if (this.settings.Files.title != null && typeof (this.settings.Files.title) != "undefined") {
        //    this.expanderFiles.setHeading(this.settings.Files.title);
        //}

        this.fileTableRows = [];

        

        this.hideNode(this.sectionAvailableFiles, false);

        if (!this.tileData.Files && !this.tileData.files?.length) {
            //this.hideNode(this.sectionAvailableFiles);
            this.UiModder.domConstruct.place(this.noEntriesNode, this.availableFilesContainer);
            return;
        }

        //this.expanderFiles.setCollapsible(this.settings.Files.isCollapsible);
        //this.expanderFiles.toggleExpand(!this.settings.Files.isCollapsed);

        let files = this.tileData.files; // neues Property ab Juli 2026, weil....
        if (!files?.length) files = this.tileData.Files.data; // noch viel komplizierter gehts eignetlich nicht oder? Gruß ans vergangene Ich. Hmpf.

        //this.hideNode(this.sectionAvailableFiles, this.settings.isEnableArchive != true);

        if (!files || files.length == 0) {
            //domConstruct.create("div", { "className": "w3-block nofiles", "innerHTML": this.translate("General__NoEntries"] }, this.availableFilesContainer);
            this.UiModder.domConstruct.place(this.noEntriesNode, this.availableFilesContainer);
        }

        this.table = <HTMLTableElement>domConstruct.create("table", { "className": "filesTable", "data-row-count": "0" }, this.availableFilesContainer);

        for (let file of files) {
            let rowIndex = this.addRowToTable();
            this.updateRowContent(rowIndex, file);
        }

        if (this.fileTableRows.length > 0) {
            this.fileTableRows[this.fileTableRows.length - 1].scrollIntoView();
        }

    }

    private addRowToTable(removeIndex?: number): number {

        if (!this.table) {
            this.prepareFilesSection();
            return this.addRowToTable();
        }

        let count: number = parseInt(this.UiModder.domAttr.get(this.table, "data-row-count"));
        let index: number = -1;

        if (removeIndex) {
            let row = this.fileTableRows[removeIndex];
            this.fileTableRows.splice(removeIndex, 1);
            index = removeIndex;

            domConstruct.destroy(row);
            count--;
        } else {

            let row = <HTMLTableRowElement>this.UiModder.domConstruct.create("tr", {}, this.table, "first");
            this.fileTableRows.push(row);
            index = this.fileTableRows.length - 1;

            this.UiModder.domAttr.set(row, "data-row-index", count.toString());

            count++;
        }
        this.UiModder.domAttr.set(this.table, "data-row-count", count.toString());
        this.sectionAvailableFiles.style.setProperty("--row-count", count.toString());

        if (count > 0) {
            this.UiModder.domConstruct.place(this.noEntriesNode, this._hiddenNode);
        }

        return index;
    }

    private updateRowContent(rowIndex: number, content: "new" | "error" | "remove" | FileFinder.FileDescriptor, additionalData?: any) {

        let row = this.fileTableRows[rowIndex];

        this.UiModder.domConstruct.empty(row);

        let col: HTMLTableColElement = null;
        let cols = [];

        if (content == "new") {
            this.UiModder.domClass.add(row, "new");

            col = this.UiModder.domConstruct.create("td", {
                "className": "new waiting",
                "data-col-name": "waitingForResponse",
                "colspan": 5
            }, row) as HTMLTableColElement;

            cols.push(col);
        }

        else if (content == "error") {
            this.UiModder.domClass.add(row, "error");

            //col = this.UiModder.domConstruct.create("td", {
            //    "className": "colIcon",
            //    "data-col-name": "errorIcon",
            //    "innerHTML": "<i class='fas fa-exclamation-circle'></i>"
            //}, row);

            if (!additionalData) {
                additionalData = "";
            }

            col = this.UiModder.domConstruct.create("td", {
                "className": "message",
                "data-col-name": "errorMessage",
                //"colspan": 4,
                "innerHTML": this.stringFormat(this.translate("FileTile__TableRow_ErrorOnRequest"), additionalData)
            }, row) as HTMLTableColElement;



            cols.push(col);
        }

        else if (content == "remove") {
            this.addRowToTable(rowIndex);
            return;
        }

        else { // content = Filedescriptor

            if (content.isFileFound) {
                this.UiModder.domClass.add(row, "downloadable hoverDark");
                on(row, "click", lang.hitch(this, this._onClick_Download, content));

                this.UiModder.domAttr.set(row, "data-download-info", content.filesizeTXT);

            }


            col = this.UiModder.domConstruct.create("td", {
                "className": "",
                "data-col-name": "title",
                "innerHTML": content.title
            }, row) as HTMLTableColElement;
            cols.push(col);

            // Spalte mit Lösch-Button
            let deleteCol = this.UiModder.domConstruct.create("td", {
                "className": "",
                "data-col-name": "delete",
                "innerHTML": "",
            }, row) as HTMLTableColElement;
            cols.push(deleteCol);

            if (content.isFileFound && content.canDelete === true) {
                let deleteBtn = this.UiModder.domConstruct.create("button", {
                    className: "mds-button-base hoverBright deleteBtn"
                }, deleteCol);
                this.createFontawesomeIcon("fas fa-trash warningTXT", "", deleteBtn);

                on(deleteBtn, "click", lang.hitch(this, this._onClick_DeleteEntry, content, rowIndex));

            } else {
                this.UiModder.domAttr.set(col, "colspan", "2");
            }


            col = this.UiModder.domConstruct.create("td", {
                "className": "colDlInfo",
                "data-col-name": "downloadInfo",
                "innerHTML": content.title
            }, row) as HTMLTableColElement;
            cols.push(col);

            if (this.hasFeature("Email/ButtonOnFileTile")) {
                col = this.UiModder.domConstruct.create("td", {
                    "className": "colEmailBtnContainer",
                    "data-col-name": "emailBtnContainer",
                    //"innerHTML": `senden<br><i class="far fa-envelope"></i>`
                }, row) as HTMLTableColElement;
                cols.push(col);

                let btn = this.UiModder.domConstruct.create("button", {
                    className: "mds-button-base mediumTransparentBG hoverDark",
                    innerHTML: TranslationHelpers.translate("General_Label_Send")
                }, col) as HTMLButtonElement;

                //let btn = new Button();
                //btn.placeAt(col);
                //btn.setLabel("xyz");
                //btn.setIconLeft("far fa-envelope");
                //btn.on("click", lang.hitch(this, this._onClick_SendEmailFile, content));

                let icon = HtmlHelpers.createFontawesomeIcon("far fa-envelope", "right", btn);

                on(btn, "click", lang.hitch(this, this._onClick_SendEmailFile, content));//
            }
        }

        this.formatCols(cols, content);
    }

    private _onClick_SendEmailFile(content: FileFinder.FileDescriptor, e: MouseEvent) {

        e.stopPropagation();
        //console.log("_onClick_SendEmailFile", content);

        let mailEditor = new emailForm();

        mailEditor.setMailFormContext({
            isHistoryContext: true,
            contextName: "filetile",
            contextEntity: content.fileEntity
        });

        //newMailForm.addNewMailBtnToDlg(mailDlg);
        mailEditor.show("dlg", content.filename, this.getTabContainerName());

        //

        mailEditor.addAttachment(content.filename, content.downloadKey, 'fileUploaderGUID');
        if (this.tileData?.title ) mailEditor.setSubject(this.tileData.title)
    }


    private _onClick_DeleteEntry(content: FileFinder.FileDescriptor, rowindex: number) {

        // TODO! request zum Löschen etc...
        alert("function not yet available >:(");
        this.updateRowContent(rowindex, "remove");
    }

    private formatCols(cols: Array<HTMLTableColElement>, value: string | FileFinder.FileDescriptor | string) {

        //console.debug("formatCols", value, cols);

        for (let col of cols) {
            let name = this.UiModder.domAttr.get(col, "data-col-name");
            let file: FileFinder.FileDescriptor = null;

            if (typeof (value) == "string") {

            } else {
                file = value;

                if (!file.isFileFound) {
                    this.UiModder.domClass.add(col.parentElement, "w3-disabled");
                }
            }

            let currentValue = col.innerHTML;



            switch (name) {
                //case "description":
                //    break;

                case "downloadKey":
                    this.UiModder.domConstruct.empty(col);

                    let button = new Button();
                    button.setLabel(this.translate("FileTile_Table_DownloadButtonLabel_NA"));
                    button.setReadonly(true);
                    button.setClasses("accentBG hoverBright", "w3-disabled", "btnDownload");
                    let dlIcon = FileHelpers.getIconClassForFileType(file.extension); //"fas fa-download";
                    if (this.hasFeature("filePreview", "useInReports")) {
                        dlIcon = "fas fa-search";
                    } else if (!dlIcon) {
                        dlIcon = "fas fa-download";
                    }
                    button.setIconLeft(dlIcon);
                    if (file.isFileFound) {
                        button.setReadonly(false);
                        on(button, "click", lang.hitch(this, this._onClick_Download, file));
                        button.setLabel(
                            this.stringFormat(
                                this.translate("FileTile_Table_DownloadButtonLabel"),
                                file.filesizeTXT )
                        );
                    }
                    button.placeAt(col);
                    break;
                case "downloadInfo":
                    this.UiModder.domConstruct.empty(col);

                    if (file.isFileFound) {
                        col.innerHTML = "";
                        if (file.extension) {
                           
                            col.innerHTML += file.extension + "<br>";

                            let dlIcon = FileHelpers.getIconClassForFileType(file.extension, true);
                            if (dlIcon) {
                                col.innerHTML = file.extension + "&nbsp;<br>";
                                HtmlHelpers.createFontawesomeIcon(dlIcon, "left", col, 1);
                            }

                        }
                        col.innerHTML += file.filesizeTXT;
                    }
                    break;
                case "title":
                    this.UiModder.domConstruct.empty(col);

                    let title = domConstruct.create("div", {
                        "innerHTML": currentValue,
                        "className": "colTitle"
                    }, col);

                    if (file.color) {
                        if (file.color.backgroundHex) {
                            this.UiModder.domClass.add(title, "colored");
                            title.style.setProperty("--symbol-color", file.color.backgroundHex);
                        }
                    }

                    if (file.description) {
                        let description = domConstruct.create("div", {
                            "innerHTML": file.description,
                            "className": "colDescription"
                        }, col);
                    }
                    break;

                case "errorMessage":
                    this.UiModder.domConstruct.empty(col);

                    //this.UiModder.domClass.add(col, "w3-disabled");
                    this.UiModder.domAttr.set(col, "colspan", "5");
                    col.innerHTML = "<i class='fas fa-exclamation-circle w3-padding-top'>&nbsp;</i>" + currentValue;

                    /* geht auch, nur anders
                    this.UiModder.domConstruct.create("i", {
                        "class": "fas fa-times w3-right hoverDark",
                        "style": "cursor: pointer; font-size: 22px",
                        "onclick": lang.hitch(this, function () {
                            this.UiModder.domConstruct.destroy(col.parentNode)
                        })
                    }, col)
                    */

                    let btn = new Button();
                    btn.setIconLeft("fas fa-times");
                    btn.setClasses("mds-button-base hoverBright btnCloseError");
                    this.UiModder.domClass.add(btn.domNode, "w3-right");
                    on(btn, "click", lang.hitch(this, function () { this.UiModder.domConstruct.destroy(col.parentNode); }))
                    btn.placeAt(col);

                    break;

                case "waitingForResponse":
                    this.UiModder.domConstruct.empty(col);

                    this.UiModder.domAttr.set(col, "colspan", "5");
                    this.UiModder.domClass.add(col, "egoAnimated_fadingHourglassOverlay")
                    col.innerHTML = "";
                    break;

                case "emailBtnContainer":
                    // sonst fällt klickevent weg
                    break;
                default:
                    //this.UiModder.domAttr.set(col, "innerHTML", currentValue);
                    break;
            }
        }
    }
    private filePreviewWidget:MdsLax<InstanceType<typeof filePreview>>;
    private _onClick_Download(entity: FileFinder.FileDescriptor) {
        if (this.hasFeature("filePreview", "useInReports") == false){
            //console.log("_onClick_Download", entity);
            // todo: das kann irgendwann zum FileTransfer/Download gelegt werden. vielleicht so ab 2025.
            location.href = window.appRoot + this.stringFormat("FileDashboard/Download?downloadKey={0}&fileName={1}.{2}",
                entity.downloadKey,
                entity.filename,
                entity.extension);
        }else{
            this.filePreviewWidget = new filePreview();
            this.StandbyStart();
            this.filePreviewWidget.show(
                {key:entity.downloadKey},
                true,
                true,
                lang.hitch(this, ()=>{
                    this.StandbyStop();
                }),
                lang.hitch(this, (err)=>{
                    this.StandbyStop();
                    console.error(err);
                    this.showToast(err, "fas fa-bug");
                })
            );
        }
    }

    private _onClick_SubmitFilterpanel(filterPanel: MdsLax<InstanceType<typeof FilterPanel>>, evt: MouseEvent) {

        let data = filterPanel.getData();
        //console.log("_onClick_SubmitFilterpanel", data);


        if (!data) {
            return;
        }

        this.requestNewFile(data);

        filterPanel.setReadonly(true);

        this.hideNode(this.animationContainer, false);
        this.UiModder.domClass.add(this.animationBar, "ego_animated_progressBar");
    }

    private requestNewFile(data: any) {

        //this.expanderFiles.toggleExpand(true);

        // die Tabelle anweisen dass sie einen Platzhalter dazuzeichnet
        let rowIndex = this.addRowToTable();
        this.updateRowContent(rowIndex, "new");

        let row = this.fileTableRows[rowIndex];
        row.scrollIntoView({ behavior: "smooth", block: "end" });


        let requestdata: FileDashboard.FileRequestData = { fileTileName: this.internalName, filterpanelData: data, rowIndex: rowIndex };

        if (this.config?.requestFileCallback) {
            this.config.requestFileCallback(requestdata);
        } else {
            this.emit("requestFile", requestdata);
        }
        
    }

    setFileRequestResponse(data: FileDashboard.FileResponseData) {
        if (data.fileTileName != this.internalName) {
            return;
        }

        // if (!this.data.Files) { // das sollte nicht passieren! die API sollte immer zumindest ein leeres Array mitgeben.
        //     this.data.Files = {
        //         data: []
        //     };
        // }

        if (!this.tileData.files) this.tileData.files = [];

        let index = data.targetRowIndex;
        let row = this.fileTableRows[data.targetRowIndex];

        if (this.filterPanel) {
            this.filterPanel.setReadonly(false);
        }

        this.hideNode(this.animationContainer);
        this.UiModder.domClass.remove(this.animationBar, "ego_animated_progressBar");

        row.scrollIntoView({ behavior: "smooth", block: "end" });

        if (data.error) {
            this.updateRowContent(index, "error", data.error);
            console.error("Fehler beim Aufrufen des neuen Files", data.error);
            return;
        }

        this.updateRowContent(index, data.fileData);
        if (this.tileData.Files?.data) {
            this.tileData.Files.data.push(data.fileData);
        }
        this.tileData.files.push(data.fileData); // löst das Files.data ab
    }

    requestCallback(error: boolean, data: any) {
        if (error) {
            console.error("new file requested - error!", data);

            return;
        } else {
            //console.log("new file requested - callback", data);
        }
    }



    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.tileData = {
            //isCollapsible: false,
            //isDownloadable: false,
            //isHTMLPreviewable: false,
            name: "??",
            title: "???",
            icon: null,
            description: null,
            order: -1,
            filterPanel: null,
            //isEnableArchive: false,
            //Files: null,
            files: null,
            color: null
        }


        if (this.hasFeature("filePreview", "useInReports")){
            this.domNode.classList.add("useFilePreview"); //siehe moreCoreDefaults.css, tauscht download icon aus
        }
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(FileTile);
